import React, { useState, useEffect, Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouseLock, faUserLock } from '@fortawesome/free-solid-svg-icons'
import { adresyPro } from "../../functions/ulice.js";
import { copyToClipboard } from '../../functions/utilities.js';

const MieszkancyListaLista = props => {

    const { mieszkancy, setMieszkaniec, setEditDataOd, setEditDataDo, udzialyKontaAkt, wybraneGrupyUdzial, ulice, lokale, grupy, grupaUdzial, setGrupaUdzial, 
        setUser, ulicaId, bezdomni, mieszkaniec, setAddGrupe, rodzajLokalu, setWybranyOdczyt, users_w, state, setLoaderOn } = props;

    const [showPwd, setShowPwd] = useState(false);
    const handlePwd = () => setShowPwd( prevState => !prevState);

    const [adresy, setAdresy] = useState([]);

    const [zestawMieszkancy, setZestawMieszkancy] = useState(undefined);
    const [lista, setLista] = useState([]);

    useEffect( () => {
        setAdresy(adresyPro(wybraneGrupyUdzial, lokale, ulice, grupy, udzialyKontaAkt, rodzajLokalu))
    },[wybraneGrupyUdzial, lokale, ulice, grupy, udzialyKontaAkt, rodzajLokalu]);

    useEffect( () => {
        const temp = adresy?.map( (adres, i) => {
            const mieszkaniec = mieszkancy?.find( m => m?.id_user == adres?.id_user);
            const user = users_w?.find( u => u?.id == adres?.id_user);

            return ({
                mieszkaniec,
                user,
                adres
            })
        });
        setZestawMieszkancy(temp);
    },[adresy, mieszkancy, users_w])

    useEffect( () => setLoaderOn(false), [zestawMieszkancy, bezdomni]);

    const ikona = (
        <FontAwesomeIcon 
            icon={faHouseLock} 
            className="pointer"
            style={{"margin": "0 10px 0 0"}}
        />);

    const handleClick = (u, m, usr) => {
        
        setEditDataOd({id: 0, show: false, dataOd: ""})
        setEditDataDo({id: 0, show: false, dataOd: ""})
        setGrupaUdzial(u)
        setMieszkaniec(m)
        setUser(usr);
        setAddGrupe(false);
        setWybranyOdczyt(undefined);
        if (state) {
            state.link_user = 0;
        }
    }

    useEffect( () => {
        const temp = ulicaId === -1 ? (
            bezdomni?.map( (b, i) => {
                const { user } = b;
                return (
                    <li 
                        key={i} 
                        className={ mieszkaniec?.id_user == b?.id_user ? "active pointer" : "pointer" }
                        onClick={()=>handleClick([], b, user)}    
                    >
                        { 
                            !showPwd ? ( 
                                <Fragment>
                                    <div>
                                        {`${b?.imie_nazwisko} (${b?.id_user}) `}
                                    </div>
                                    {
                                        b?.czy_nota == ""
                                    }
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <div>
                                        {`${b?.imie_nazwisko} (${b?.id_user})`}
                                    </div>
                                    <div style={ {"textAlign": "right", "maxWidth": "70px"} } >
                                        <span onClick={copyToClipboard} >
                                            {user?.user}
                                        </span>
                                    </div>
                                    <div style={ {"textAlign": "right", "maxWidth": "70px"} } >
                                        <span onClick={copyToClipboard} >
                                            {user?.password}
                                        </span>
                                    </div>
                                </Fragment>
                            )
                        }
                    </li>
                )
            })
        ) : (
            zestawMieszkancy?.map( ( zestaw, i) => {
                const { mieszkaniec, user, adres } = zestaw;
                return (
                    <li 
                        key={i} 
                        className={ user?.id == grupaUdzial?.id_user && adres?.grupa_numer == grupaUdzial?.grupa_numer ? "pointer active" : "pointer"  } 
                        onClick={()=>handleClick(adres?.udzialGrupa, mieszkaniec, user)} 
                    >
                        { !showPwd ? ( <Fragment>
                                    <div>
                                        { adres?.czyZamkniety ? ikona : "" } 
                                        {`${adres?.adres}, ${mieszkaniec?.imie_nazwisko} (${mieszkaniec?.id_user}) `}
                                    </div>
                                    { mieszkaniec?.czy_nota == "" }
                                </Fragment>
                            ) : ( <Fragment>
                                    <div>
                                        { adres?.czyZamkniety ? ikona : "" }
                                        { `${adres.adres}, ${mieszkaniec?.imie_nazwisko} (${mieszkaniec?.id_user})`}
                                    </div>
                                    <div
                                        style={ {"textAlign": "right", "maxWidth": "70px"} }
                                    >
                                        <span onClick={copyToClipboard}>
                                            {`${user?.user}`}
                                        </span>
                                    </div>
                                    <div
                                        style={ {"textAlign": "right", "maxWidth": "70px"} }
                                    >
                                        <span 
                                            onClick={copyToClipboard}
                                        >
                                            {user?.password}
                                        </span>
                                    </div>
                                </Fragment> ) }
                    </li>
                )
            })
        );
        setLista(temp);
    },[ulicaId, showPwd, bezdomni, zestawMieszkancy, mieszkaniec]);

    return (
        <div className="ramka" style={{backgroundColor: "var(--wnetrzeRamki)"}}>
            <ul className="lista" tabIndex={0} >
                <li>
                    <div>
                        <span>Imię i nazwisko </span>
                        <FontAwesomeIcon 
                            icon={faUserLock} 
                            className="pointer"
                            style={{"margin": "0 0 0 30px"}}
                            onClick={handlePwd}
                        />
                    </div>
                </li>
                { lista }
            </ul>
        </div>
    )
}

export default MieszkancyListaLista;